// paulcollett.com
// Updated may '15

(function($){

	 var formHandler = function(opts){

		 var _this = this,
	 	$form = $(this).eq(0).attr('novalidate',1),
	 	validate = function(){

			  var $invalid = $form.find('[required]').filter(':not([type=checkbox],[type=radio])')
					.filter(function(){ return $(this).val().replace(/^\s+|\s+$/g,'') === ''; })
					.add($form.find('input[type=checkbox][required]:not(:checked)').filter(function(){
						 return !$form.find('input[name="' + $(this).attr('name') + '"]:checked').length; }))
					.add($form.find('input[type=radio][required]').filter(function(){
						 return $form.find('input[name="' + $(this).attr('name') + '"]').serialize() === ''; }))
					.add($form.find('input[type=email]').filter(function(){
						 return $(this).val() !== '' && !/^.+?@[a-zA-Z_]+?\..+$/.test($(this).val()); }))
					.add($form.find('[pattern]').filter(function(){
						 return !new RegExp('^' + $(this).attr('pattern') + '$').test($(this).val()); }));

			  if($invalid.length){
					if (opts.error && opts.error.call(_this,'Oops, some fields are invalid or required',$invalid));
					return false;
			  }

		},
		submit = function(e){
			  e.preventDefault();

			  if (opts.loading && 
			  		opts.loading.call(_this) === false || 
			  		validate() === false) {
			  	return;
			  }

			  $[($form.attr('method')||'post').toLowerCase()]($form.attr('action')||'',$form.serialize()+ '&_ajax=true',function(r) {
					var json = false;
					try {
						json = r && (r.ok || r.error) ? r : $.parseJSON(r);
					} catch(e) {

					}
//console.log(r);
//console.log(json);
//console.log(opts);
//console.log(e);
					json && json.ok ? opts.success && opts.success.call(_this,json)
						: opts.error && opts.error.call(_this,json.error || 'Sorry, could not submit at this time',$()); // jshint ignore:line
			  }).fail(function(){
					if (opts.error && opts.error.call(_this,'Oops, form setup error',$()));
			  });

		};

		$form.submit(submit).find('.submit').on('click',submit);

	};

	$.fn.formHandler = function(opts){ $(this).each(function(){ formHandler.call(this,opts); }); };

})(window.jQuery||window.$);

/*

<form id="myform" method="post" action="script.php">

	<div> Name: <input type="text" name="name" /> </div>

	<div> Email*: <input type="email" name="email" required /> </div>

	<div> Phone*: <input type="tel" name="number" required pattern="\d+" /> </div>

	<div>
		Options*:
			<input type="radio" name="option" value="1" required /> 1,
			<input type="radio" name="option" value="2" required /> 2
	</div>

	<div> Message: <textarea name="message" required></textarea> </div>

	<input type="submit" />

</form>

*/

/*

Super tiny jQuery form validation with ajax loading, error & success states.
Abides by HTML5 form validation

$('#myform').formHandler({
	loading: function(){

		$(this).

	},
	error:function(genericMessage,$errorFields){

		// Add .error class to fields
		$errorFields.addClass('error').one('input change',function(){
			$form.find('[name="' + $(this).attr('name') + '"]').add(this).removeClass('error');
		});

		if($errorFields.filter('[name=email]').length){
			alert('Email is required');
		}else{
			alert(genericMessage);
		}

	},
	success:function(jsonResponse){

	}
});
*/

